export default class ChipHelper {
    public static Denominations: number[] = [10, 5, 1];
}
